function getValueFromJsonString({
  jsonString,
  keyToFind,
}: {
  jsonString: string | null;
  keyToFind: string;
}): string {
  if (!jsonString) {
    return "";
  }

  try {
    const jsonObject = JSON.parse(jsonString);
    if (typeof jsonObject === "object" && jsonObject !== null) {
      for (const key in jsonObject) {
        if (
          Object.prototype.hasOwnProperty.call(jsonObject, key) &&
          key.toLowerCase() === keyToFind.toLowerCase()
        ) {
          const value = jsonObject[key];
          return typeof value === "string" ? value : "";
        }
      }
    }
  } catch (error) {
    console.error("Failed to parse JSON string:", error);
  }
  return "";
}

export { getValueFromJsonString };
